import {observer} from 'mobx-react-lite';
import React, {useContext} from 'react';
import {Pressable, StyleSheet} from 'react-native';

import DailyAchievementView from '../DailyAchievementView';
import TabsContext from './TabsContext';

export type DailyAchievementBindingProps = DailyAchievementProps;

export type DailyAchievementProps = {
  days?: number;
  months?: number;
  years?: number;
};

export default observer(function DailyAchievementBinding(
  props: DailyAchievementBindingProps,
) {
  const {days, months, years} = props;
  const {accretion, onPress, onPressIn, onPressOut} =
    useContext(TabsContext) ?? {};
  return (
    <Pressable onPressIn={onPressIn} onPressOut={onPressOut} onPress={onPress}>
      <DailyAchievementView
        pointerEvents="box-only"
        style={styles.root}
        days={days}
        months={months}
        years={years}
        accretion={accretion}
      />
    </Pressable>
  );
});

const styles = StyleSheet.create({
  root: {
    pointerEvents: 'box-only',
  },
});
